import { SearchOutlined } from "@ant-design/icons";
import { Avatar, Button, Image, Skeleton, Tabs, message } from "antd";
import {
  StudentJoinClass,
  StudentJoinClassSession,
  StudentJoinOrganismClass,
  findAllClasses,
} from "api/services/studentJoinClass/studentJoinClass.services";
import { Field, Form, Formik } from "formik";
import React, { FC, Fragment, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppScreen from "screens/teacher/ScreenWithSidebar";
import { SudentJoinClassSchema } from "validations";

//!STYLE
import Breadcrumbs from "components/breadcrumbs";
import st from "../calendar/assets/calendar.module.css";
import s from "./assets/myClasses.module.css";
import style from "./assets/organismClass.module.css";

//!IMAGE
import { StatusCode, calculateTimeDifference, isToday } from "common/enums";
import Flex from "components/libs/flex";
import * as appRoutes from "config/routes.config";
import Camera from "../../../assets/images/app/camera.svg";
import ClockIcon from "../../../assets/images/app/clock_icon.svg";
import CoursesIcons from "../../../assets/images/app/Cours.svg";
import EllipseTeacherProfileFour from "../../../assets/images/app/ellipse_teacher_profile4.png";
import EllipseTeacherProfileFive from "../../../assets/images/app/ellipse_teacher_profile5.png";
import Organism from "../../../assets/images/app/iam_organism.svg";
import StarIcon from "../../../assets/images/app/start.svg";
import ClassesIcons from "../../../assets/images/icons/teacher_classes.svg";
import CardTeacher from "../components/cardTeacher";
import Key from "./assets/key.svg";

import AppDrawer from "components/appDrawer";
import { AppNotification } from "components/appNotification";
import AppResult from "components/appResults";
import CertificationBadge from "components/certificationBadge";
import AppButton from "components/libs/button";
import H1 from "components/libs/title";
import Matiers from "components/matiers";
import { useLocation, useNavigate } from "react-router-dom";
import { setCheckClass } from "store/app/appSlice";
import { openProfileDetailsDrawer, setProfileDetailsID, setProfileDetailsType } from "store/auth/authSlice";
import { useGetOrganismRoomsQuery, useGetStudentReservationsQuery } from "store/services/teacher/classes.services";


interface CoursesRoomProps {
  course?: object | any;
}

const CoursesRoom: FC<CoursesRoomProps> = ({ course }) => {

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  const handleProfileDetails = () => {
    if (auth?.user?._id === course?.profId?._id) return;

    dispatch(setProfileDetailsID(course?.profId?.uid));
    dispatch(setProfileDetailsType("teacher"));
    dispatch(openProfileDetailsDrawer());
  }

  return (
    <div className={st.classeCard} style={{ cursor: "pointer" }}>
      <div className={st.cardClassBox}>
        <div className={st.avatarNameBox} onClick={() => handleProfileDetails()}>
          <Avatar.Group
            maxCount={3}
            maxStyle={{
              color: "#f56a00",
              backgroundColor: "#fde3cf",
            }}
            style={{ marginRight: isMobile ? "0px" : "5px" }}
          >
            <Avatar
              size={45}
              style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
              src={course?.profId?.profile}
            />
          </Avatar.Group>
          <div style={{ fontSize: isMobile ? "1em" : "13px", display: "flex", flexDirection: "column", alignItems: isMobile ? "center" : "flex-start", justifyContent: isMobile ? "center" : "flex-start" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: isMobile ? "center" : "flex-start", justifyContent: isMobile ? "center" : "flex-start", textTransform: "capitalize" }}>{course?.profId?.firstname + " " + course?.profId?.lastname} {course?.profId?.certified && <CertificationBadge />}</div>
            <span style={{ color: "#707070" }}>{course?.profId?.rateCours} <img src={StarIcon} height={10}></img> ({course?.profId?.reservationsRateNum || 0} avis)</span>
          </div>
        </div>
        {isMobile && course?.typeCreneaux !== "collectif" && course?.topic?.title && course?.level?.title && <Matiers
          cours={course?.topic?.title || "null"}
          level={course?.level?.title || "null"}
        />}
        <div className={st.detailsBox}>
          <div className={st.timeBox}>
            {!isMobile && <img src={ClockIcon} height={15} style={{ marginRight: "10px" }}></img>}
            <div className={st.times}>
              <span className={st.time}>{isMobile && <img src={ClockIcon} height={10} style={{ marginRight: "5px" }}></img>} De {course?.range[0]} à {course?.range[course?.range?.length - 1]}</span>
              <span className={st.timeDescription}>Séance de “{calculateTimeDifference(course?.range[0], course?.range[course?.range.length - 1])}”</span>
            </div>
          </div>
          {!isMobile && course?.typeCreneaux !== "collectif" && course?.topic?.title && course?.level?.title && <div style={{ width: "auto" }}>
            <Matiers
              cours={course?.topic?.title || "null"}
              level={course?.level?.title || "null"}
            />
          </div>}
          <div className={st.amountBox}>
            Séance réservée pour
            {course?.typeCreneaux !== "collectif" ? <div className={st.priceBox}>{(course?.byCredits === "oui" || course?.byCredits === "true") ? course?.creditedValue + " Crédit" : course?.price + " €"}</div> :
              <div className={st.priceBox}>{course?.pricePerStudent ? course?.pricePerStudent + " Crédit" : course?.price + " Crédit"}</div>}
          </div>
        </div>

        <a href={course?.typeCreneaux !== "collectif" ? course?.studentLink : course?.commonLink} target="_blank">
          <Button className={s.meetButton} icon={<img src={Camera} height={10} style={{ marginRight: "10px" }} />}>
            Lien vidéoconf
          </Button>
        </a>
      </div>
    </div>
  );
};

const { TabPane } = Tabs;

const MyClasses: FC = () => {
  //!HOOK
  const { user } = useSelector((state) => state.auth);
  const { data, isLoading, isError, refetch } = useGetStudentReservationsQuery(user?._id);
  const { data: organismRooms, isLoading: loadingOrganismRooms, refetch: refetchOrganismRooms } = useGetOrganismRoomsQuery(user?._id);

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(appRoutes.STUDENT_SEARCH_BEST_TEACHER);
  }

  const location = useLocation();

  const [classCode, setClassCode] = useState<any>("");
  const [organismToken, setOrganismToken] = useState<any>("");
  const [organismClassCode, setOrganismClassCode] = useState<any>("");

  //!STATE
  const [drawer, setDrawer] = useState<boolean>(false);
  const [organismClassDrawer, setOrganismClassDrawer] = useState<boolean>(false);
  const [teachers, setTeachers] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentTab, setCurrentTab] = useState<any>("1");
  const dispatch = useDispatch();
  const [courses, setCourses] = useState<any>([]);

  const { checkClass } = useSelector((state) => state.app);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  //!FUNCTION
  const showDrawer = () => setDrawer(true);
  const showOrganismClassDrawer = () => setOrganismClassDrawer(true);

  const onClose = () => {
    setDrawer(false);
    localStorage.setItem("classCode", "");
  };

  const onCloseOrganismClassDrawer = () => {
    setOrganismClassDrawer(false);
    localStorage.setItem("organismClassCode", "");
    localStorage.setItem("organismToken", "");
    localStorage.setItem("userType", "");
  };

  const getTeacher = useCallback(async () => {
    setLoading(true);
    try {
      const response = await findAllClasses(user?._id);
      if (response) {
        setTeachers(response.data);
      }
    } catch (error: any) {
      message.error("Error");
    } finally {
      setLoading(false);
    }
  }, []);

  const joinClassForm = useCallback(async (values: any) => {
    localStorage.setItem("classCode", "");
    try {
      if (values?.code && user?._id) {
        const response = await StudentJoinClass(values?.code, user?._id);
        if (response.statusCode === StatusCode.CREATED) {
          getTeacher();
          setDrawer(false);
          AppNotification(
            "Tu as rejoint la classe avec succès !",
            "AlbertVeryHappy"
          );
        }
      }
    } catch (error: any) {
      if (error.response.status === 409) {
        message.warning("Vous avez déjà rejoint cette classe !");
      } else if (error.response.status === 404) {
        AppNotification("Le code saisi n'est pas valide", "AlbertSad");
      } else {
        message.error("Une erreur inconnue est survenue");
      }
    }
  }, []);

  const joinClass = useCallback(async (code: string) => {
    try {
      if (code && user?._id) {
        const response = await StudentJoinClass(code, user?._id);
        if (response.statusCode === StatusCode.CREATED) {
          getTeacher();
          setDrawer(false);
          AppNotification(
            "Tu as rejoint la classe avec succès !",
            "AlbertVeryHappy"
          );
          localStorage.setItem("classCode", "");
        }
      }
    } catch (error: any) {
      if (error.response.status === 409) {
        message.warning("Vous avez déjà rejoint cette classe !");
      } else if (error.response.status === 404) {
        AppNotification("Le code saisi n'est pas valide", "AlbertSad");
      } else {
        message.error("Une erreur inconnue est survenue");
      }
    }
  }, []);

  const joinOrganismClass = useCallback(async (code: string, token: string) => {
    try {
      if (code && user?._id && token) {
        setLoading(true);
        const response = await StudentJoinOrganismClass(code, user?._id, token);
        if (response.statusCode === StatusCode.CREATED) {
          getTeacher();
          setOrganismClassDrawer(false);
          AppNotification(
            "Tu as rejoint la classe avec succès !",
            "AlbertVeryHappy"
          );
          localStorage.setItem("organismClassCode", "");
          localStorage.setItem("organismToken", "");
          localStorage.setItem("userType", "");
          refetch();
          refetchOrganismRooms();
          setCurrentTab("3");
        }
      }
    } catch (error: any) {
      if (error.response.status === 409) {
        message.warning("Vous avez déjà rejoint cette classe !");
      } else if (error.response.status === 404) {
        AppNotification("Le code saisi n'est pas valide", "AlbertSad");
      } else {
        message.error("Une erreur inconnue est survenue");
      }
    } finally {
      setLoading(false);
    }
  }, [organismToken]);

  const joinOrganismClassForm = useCallback(async (values: any) => {
    try {
      if (values && user?._id) {
        setLoading(true);
        const response = await StudentJoinOrganismClass(values?.code, user?._id, organismToken);
        if (response.statusCode === StatusCode.CREATED) {
          getTeacher();
          setOrganismClassDrawer(false);
          AppNotification(
            "Tu as rejoint la classe avec succès !",
            "AlbertVeryHappy"
          );
          localStorage.setItem("organismClassCode", "");
          localStorage.setItem("organismToken", "");
          localStorage.setItem("userType", "");
          refetch();
          refetchOrganismRooms();
          setCurrentTab("3");
        }
      }
    } catch (error: any) {
      if (error.response.status === 409) {
        message.warning("Vous avez déjà rejoint cette classe !");
      } else if (error.response.status === 404) {
        AppNotification("Le code saisi n'est pas valide", "AlbertSad");
      } else {
        message.error("Une erreur inconnue est survenue");
      }
    } finally {
      setLoading(false);
    }
  }, [organismToken]);

  const joinClassSession = useCallback(async (studentId: string, token: string, collectiveId: string) => {
    try {
      if (studentId && token && collectiveId) {
        setLoading(true);
        const response = await StudentJoinClassSession(studentId, token, collectiveId);
        if (response.statusCode === StatusCode.CREATED) {
          AppNotification(
            "Tu as rejoint le cours collectif avec succès !",
            "AlbertVeryHappy"
          );
          localStorage.setItem("collectiveToken", "");
          localStorage.setItem("sessionId", "");
          localStorage.setItem("classeId", "");
        }
      }
    } catch (error: any) {
      if (error.response.status === 409) {
        message.warning("Vous avez déjà rejoint cette classe !");
      } else if (error.response.status === 404) {
        AppNotification("Le code saisi n'est pas valide", "AlbertSad");
      } else {
        message.error("Une erreur inconnue est survenue");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSeeClass = (teacherId: string) => {
    navigate(`${appRoutes.STUDENT_MY_CLASS}/${teacherId}`);
  }

  useEffect(() => {
    getTeacher();
  }, [getTeacher]);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (data?.data) {
      const sortedCourses = [...data.data].sort(
        (a: any, b: any) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
      );

      const groupedByDate = sortedCourses.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setCourses(groupedByDate);
    }
  }, [data]);

  useEffect(() => {
    if (checkClass) {
      setCurrentTab("2");
      setTimeout(() => {
        dispatch(setCheckClass(false));
      }, 2000);
    }
  }, [checkClass]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (user) {
      if (searchParams !== undefined) {
        const classCode = searchParams.get('classCode');
        if (classCode !== null) {
          setClassCode(classCode);
          showDrawer();
          joinClass(classCode);
        }
      }
    }
  }, [user, location.search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (user) {
      if (searchParams !== undefined) {
        const organismClassCode = searchParams.get('organismClassCode');
        const organismToken = localStorage.getItem("organismToken");
        const userType = localStorage.getItem("userType");
        if (organismToken && organismClassCode && userType) {
          setCurrentTab("3");
          setOrganismToken(organismToken);
          setOrganismClassCode(organismClassCode);
          showOrganismClassDrawer();
          joinOrganismClass(organismClassCode, organismToken);
        }
      }
    }
  }, [user, location.search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (user) {
      if (searchParams !== undefined) {
        const classeId = searchParams.get('classeId');
        const collectiveToken = localStorage.getItem("collectiveToken");
        const sessionId = localStorage.getItem("sessionId");
        if (collectiveToken && sessionId && classeId) {
          setCurrentTab("3");
          joinClassSession(user?._id, collectiveToken, sessionId);
        }
      }
    }
  }, [user, location.search]);

  return (
    <React.Fragment>
      {isMobile && user?.accountManaged !== "" && <div style={{ height: "0px", width: "100%" }}></div>}
      {!isMobile && <Breadcrumbs isRooms={true} />}
      <AppScreen>
        {!isMobile && <img src={EllipseTeacherProfileFour} height={106} style={{ position: "absolute", top: "25%", left: "0px", zIndex: "-1" }}></img>}
        {!isMobile && <img src={EllipseTeacherProfileFive} height={54} style={{ position: "absolute", top: "35%", left: "94%", zIndex: "-1" }}></img>}
        <div style={{ marginBottom: isMobile ? "0px" : "80px" }}>
          <Tabs
            tabBarStyle={{ borderRadius: "0px", overflow: "hidden", border: "0px solid transparent !important", backgroundColor: "transparent !important" }}
            activeKey={currentTab}
            onChange={(key) => setCurrentTab(key)}
            type="line"
          >
            <TabPane
              tab={
                <div className={currentTab == "1" ? s.tabTitleBoxActive : s.tabTitleBox}>
                  <img src={CoursesIcons} height={18} style={{ marginRight: "10px" }}></img> Mes cours particuliers
                </div>
              }
              key="1"
            >
              <div className={s.informationBox} style={{ justifyContent: data?.data?.length === 0 ? "center" : "flex-start", alignItems: "center" }}>

                {isLoading && (
                  <React.Fragment>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                  </React.Fragment>
                )}

                {!isLoading && data?.data?.length > 0 ? (
                  courses && Object.keys(courses)?.map((date) => {
                    return (
                      <>
                        <div key={date} style={{ marginTop: "10px" }}>
                          <div className={s.dateBox}>
                            {new Intl.DateTimeFormat("fr-FR", {
                              weekday: "long",
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            }).format(new Date(date))}
                            {isToday(date) && <div className={s.todayBox}>Aujourd’hui</div>}
                            <div className={s.horizontalLine}></div>
                          </div>
                          {!isMobile && courses[date].map((course: any) => (
                            <div key={course.id}>
                              <CoursesRoom course={course} />
                            </div>
                          ))}

                          {isMobile && <div className={s.cardDisplay} /* className={`${s.cardDisplay} ${courses[date].length === 1 ? s.singleCourse : ""}`} */>
                            {courses[date].map((course: any) => (
                              <div key={course.id}>
                                <CoursesRoom course={course} />
                              </div>
                            ))}
                          </div>}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <AppResult status={"info"} title="Aucune séance" />
                    <Button className={s.newButton} icon={<SearchOutlined />} onClick={handleClick} style={{ marginTop: "20px" }}>
                      Trouver un prof
                    </Button>
                  </div>
                )}
              </div>
            </TabPane>
            <TabPane
              tab={
                <div className={currentTab == "2" ? s.tabTitleBoxActive : s.tabTitleBox}>
                  <img src={ClassesIcons} height={18} style={{ marginRight: "10px" }}></img> Mes classes
                </div>
              }
              key="2"
            >
              <div className={s.classesBox}>
                <div className={s.newClassBox}>
                  <Button className={s.newButton} onClick={showDrawer}>
                    Rejoindre une classe
                  </Button>
                </div>

                <div style={{ marginTop: isMobile ? "0px" : "30px", overflowY: "scroll", scrollbarWidth: "thin" }}>
                  {loading && (
                    <React.Fragment>
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                    </React.Fragment>
                  )}

                  {!loading && teachers.length > 0 && !isMobile && (
                    <Flex>
                      <React.Fragment>
                        {teachers?.map((teacher: any) => (
                          teacher?.teacher && <CardTeacher teacher={teacher} />
                        ))}
                      </React.Fragment>
                    </Flex>
                  )}

                  {!loading && teachers.length > 0 && isMobile && <div className={s.cardDisplay} /* className={`${s.cardDisplay} ${courses[date].length === 1 ? s.singleCourse : ""}`} */>
                    {teachers?.map((teacher: any) => (
                      <div key={teacher?.teacher?._id}>
                        {teacher?.teacher && <CardTeacher teacher={teacher} />}
                      </div>
                    ))}
                  </div>}

                  {!loading && teachers.length <= 0 && (
                    <div className={s.__result}>
                      <AppResult
                        status="info"
                        title="Aucune classe"
                      />
                    </div>
                  )}
                </div>
              </div>
            </TabPane>
            <TabPane
              tab={
                <div className={currentTab == "3" ? s.tabTitleBoxActive : s.tabTitleBox}>
                  <img src={ClassesIcons} height={18} style={{ marginRight: "10px" }}></img> Mes classes de cours collectifs
                </div>
              }
              key="3"
            >
              <div className={s.classesBox}>
                <div style={{ marginTop: "30px", overflowY: "scroll", scrollbarWidth: "thin", height: "640px" }}>
                  {loadingOrganismRooms && (
                    <React.Fragment>
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                    </React.Fragment>
                  )}

                  {!loadingOrganismRooms && (
                    <Fragment>
                      <Flex>
                        <Fragment>
                          {organismRooms?.data?.map((classRoom: any) => (
                            <div className={style.card}>
                              <div className={style.cardContent}>
                                <div className={style.detailsAvatarBox}>
                                  <img src={Organism} height={isMobile ? 35 : 65} style={{ borderRadius: "50%" }}></img>
                                </div>

                                <div className={s.className}>
                                  <span>{classRoom?.title || classRoom?.name || ""}</span>
                                </div>
                                <div style={{ marginTop: "10px", fontSize: "1em", fontWeight: "600" }}>
                                  <span>{classRoom?.registeredStudents.length + " élèves"}</span>
                                </div>
                                <div style={{ marginTop: "10px", marginBottom: "20px", fontSize: "1em", fontWeight: "600" }}>
                                  <span>{classRoom?.teacherCreditsSpent + " crédits"}</span>
                                </div>

                                {classRoom?.teacher && <Button onClick={() => handleSeeClass(classRoom?._id)} className={style.dropdown}>
                                  Voir la Classe
                                </Button>}
                              </div>
                            </div>
                          ))}
                        </Fragment>
                      </Flex>
                    </Fragment>
                  )}
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </AppScreen>

      <AppDrawer
        title={false}
        width={"60%"}
        onClose={onClose}
        visible={drawer}
      >
        <div className={s.__drawer__body}>
          <H1>Rejoindre une classe</H1>

          <p>
            Pour participer à une classe virtuelle, entre le code que ton professeur t'a fourni ci-dessous. Une fois le code validé, tu seras ajouté à la classe et pourras accéder à tous les matériaux partagés, participer à des quiz, et voir ton classement parmi tes camarades.
          </p>
          <p>
            C'est une excellente manière de renforcer ton apprentissage et de te mesurer à tes pairs en toute convivialité.{" "}
          </p>

          <Formik
            initialValues={{
              code: classCode ? classCode : "",
            }}
            validationSchema={SudentJoinClassSchema}
            onSubmit={joinClassForm}
          >
            {({ errors, touched }) => (
              <Form style={{ position: "relative" }}>
                <div className={s.__join__class}>
                  <Field
                    name="code"
                    type="text"
                    placeholder="Insérer le code de la classe "
                  />
                  <Image
                    src={Key}
                    preview={false}
                    width={15}
                    onClick={onClose}
                    className={s.__key}
                  />
                </div>
                {errors.code && touched.code ? (
                  <div className={s.__error}>
                    <span>{errors.code}</span>
                  </div>
                ) : null}

                <div className={s.joinClassButtonBox}>
                  <AppButton
                    loading={loading}
                    htmlTypeSubmit={true}
                    className={s.meetButton}
                  >
                    Rejoindre la classe
                  </AppButton>
                </div>

              </Form>
            )}
          </Formik>
        </div>
      </AppDrawer>

      <AppDrawer
        title={false}
        width={"60%"}
        onClose={onCloseOrganismClassDrawer}
        visible={organismClassDrawer}
      >
        <div className={s.__drawer__body}>
          <H1>Rejoindre une classe</H1>

          <p>
            Pour participer à une classe virtuelle, entre le code reçu par email. Une fois le code validé, tu seras ajouté à la classe et pourras accéder à tous les matériaux partagés, participer à des quiz, et voir ton classement parmi tes camarades.
          </p>
          <p>
            C'est une excellente manière de renforcer ton apprentissage et de te mesurer à tes pairs en toute convivialité.{" "}
          </p>

          <Formik
            initialValues={{
              code: organismClassCode ? organismClassCode : "",
            }}
            validationSchema={SudentJoinClassSchema}
            onSubmit={joinOrganismClassForm}
          >
            {({ errors, touched }) => (
              <Form style={{ position: "relative" }}>
                <div className={s.__join__class}>
                  <Field
                    name="code"
                    type="text"
                    placeholder="Insérer le code de la classe "
                  />
                  <Image
                    src={Key}
                    preview={false}
                    width={15}
                    onClick={onCloseOrganismClassDrawer}
                    className={s.__key}
                  />
                </div>
                {errors.code && touched.code ? (
                  <div className={s.__error}>
                    <span>{errors.code}</span>
                  </div>
                ) : null}

                <div className={s.joinClassButtonBox}>
                  <AppButton
                    loading={loading}
                    htmlTypeSubmit={true}
                    className={s.meetButton}
                  >
                    Rejoindre la classe
                  </AppButton>
                </div>

              </Form>
            )}
          </Formik>
        </div>
      </AppDrawer>
    </React.Fragment>
  );
};

export default MyClasses;
